import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const ChapterHead = ({ num, kicker, title }) => (
  <div className="mb-12 sm:mb-16">
    <Reveal>
      <p className="font-mono text-xs uppercase tracking-[0.3em] text-gold-400 mb-4" data-testid={`chapter-label-${num}`}>
        {num} — {kicker}
      </p>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-extrabold tracking-tight text-white max-w-3xl leading-tight">
        {title}
      </h2>
    </Reveal>
  </div>
);
